// @ts-strict-ignore
import { Errors } from 'src/modules/community/write/components/sharedStyles';
export default function WritePostErrors({
  errors,
  dataTestId
}) {
  if (!errors.length) return null;
  return <Errors data-testid={dataTestId} data-sentry-element="Errors" data-sentry-component="WritePostErrors" data-sentry-source-file="writePostErrors.tsx">
      {errors.map(({
      text
    }) => <span key={text}>{text}</span>)}
    </Errors>;
}